/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=1bf8e29f&scoped=true&"
import script from "./file-upload.vue?vue&type=script&lang=ts&"
export * from "./file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=1bf8e29f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8e29f",
  null
  
)

export default component.exports